import { Fragment, useState } from 'react';
import { pageSectionsDummyData } from './dummyData';
import PageSection from './PageSection';
import { FieldArray, Form, Formik } from 'formik';
import Button from '../../../components/buttons/Button';
import { plusIcon } from '../../../config/variables';
import { useTranslation } from 'react-i18next';

export default function PageSectionsEdit() {
  const [expanded, setExpanded] = useState(0);
  const { t } = useTranslation();


  return (
    <Formik
      validateOnMount
      enableReinitialize
      initialValues={{
        sections: [...pageSectionsDummyData?.sections]
      }}
      onSubmit={() => {
        console.log('submitted parent');
      }}
    >
      {(formik) => (
        <Form>
          <FieldArray
            name={`sections`}
            render={(arrayHelpers) => {
              return (
                <Fragment>
                  <div className="accordions-container">
                    {formik?.values?.sections?.map((section, index) => {
                      return <PageSection arrayHelpers={arrayHelpers} data={section} expanded={expanded} setExpanded={setExpanded} index={index} />;
                    })}
                  </div>
                  <Button
                    customClass="add-section_btn"
                    onClick={() => {
                      arrayHelpers.push({});
                    }}
                  >
                    <div className="add-section_btn_content">
                      {plusIcon} {t('add_section')}
                    </div>
                  </Button>
                </Fragment>
              );
            }}
          />
        </Form>
      )}
    </Formik>
  );
}
